import React from 'react';
import PropTypes from 'prop-types';
import { EMPTY_OBJECT } from '../../constants';

const SIDES = ['top', 'right', 'bottom', 'left'];

function nextSide(side, step = 1) {
  const index = SIDES.indexOf(side);
  if (index < 0) {
    throw new Error(`${side} is not a valid side`);
  }

  const next = (index + SIDES.length + step) % SIDES.length;
  return SIDES[next];
}

function capitalize(str) {
  switch ((str || '').length) {
    case 0:
      return str;
    case 1:
      return str.toUpperCase();
    default:
      return str.slice(0, 1).toUpperCase() + str.slice(1).toLowerCase();
  }
}

class Section extends React.PureComponent {
  static propTypes = {
    backgroundColor: PropTypes.string,
    angle: PropTypes.number,
    topAngle: PropTypes.number,
    topMargin: PropTypes.number,
    bottomAngle: PropTypes.number,
    bottomMargin: PropTypes.number,
    style: PropTypes.object,
    contentStyle: PropTypes.object,
  };

  static defaultProps = {
    backgroundColor: undefined,
    angle: 0,
    topAngle: 0,
    topMargin: 1,
    bottomAngle: 0,
    bottomMargin: 1,
    style: EMPTY_OBJECT,
    contentStyle: EMPTY_OBJECT,
  };

  render() {
    const {
      backgroundColor,
      angle,
      topAngle,
      topMargin,
      bottomAngle,
      bottomMargin,
      style,
      contentStyle,
      children,
      ...otherProps
    } = this.props;

    const containerStyle = { pointerEvents: 'none', ...style };
    const contentStyleMerged = {
      paddingTop: angle || topAngle ? '1px' : undefined,
      paddingBottom: angle || bottomAngle ? '1px' : undefined,
      backgroundColor: backgroundColor,
      pointerEvents: 'auto',
      ...contentStyle,
    };

    return (
      <div style={containerStyle}>
        <Triangle
          side="top"
          angle={angle || topAngle}
          color={backgroundColor}
          margin={topMargin}
        />
        <div style={contentStyleMerged}>{children}</div>
        <Triangle
          side="bottom"
          angle={angle || bottomAngle}
          color={backgroundColor}
          margin={bottomMargin}
        />
      </div>
    );
  }
}

export default Section;

function Triangle({ side, angle, color, margin, children }) {
  const slope = Math.tan(Math.abs(angle) * Math.PI / 180);

  let step = -1;
  if (angle < 0) {
    step = 1;
  }

  const realSide = nextSide(side, 2);
  const adjacent = nextSide(realSide, step);
  const oppositeA = nextSide(realSide, 2);
  const oppositeB = nextSide(adjacent, 2);

  const style = {
    borderWidth: `${slope * 50}vw 50vw`,
    borderStyle: 'solid',
    pointerEvents: 'none',
  };

  style[`margin${capitalize(side)}`] = `${margin * slope * -100}vw`;

  [
    [realSide, color],
    [adjacent, color],
    [oppositeA, 'transparent'],
    [oppositeB, 'transparent'],
  ].map(
    ([postfix, value]) => (style[`border${capitalize(postfix)}Color`] = value),
  );

  return <div style={style}>{children}</div>;
}



// WEBPACK FOOTER //
// ./src/components/Section/Section.js